import Container from '../containers/sign';

export default function Sign() {
  return (
    <>
      <Container />
    </>
  );
}
